import React from 'react';
import { Desc, TipsAlert, TipsIcon, Title } from './Tips.styles';

const Tips = ({ title, description, isSticky = false, showIcon = true }) => {
  return (
    <TipsAlert
      isSticky={isSticky}
      message={
        <Title>
          {showIcon && <TipsIcon />}
          {title}
        </Title>
      }
    description={<Desc>{description}</Desc>}
    />
  );
};

export default Tips;
